import { render, staticRenderFns } from "./SubscriptionComment.vue?vue&type=template&id=34804e6e&scoped=true"
import script from "./SubscriptionComment.vue?vue&type=script&lang=js"
export * from "./SubscriptionComment.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionComment.vue?vue&type=style&index=0&id=34804e6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34804e6e",
  null
  
)

export default component.exports